module.exports = {
  renderer: [ 'type', require(44) ],
  styles: [ 'type', require(45) ]
};